import Axios from 'axios';
// import { instrumentAxiosInstance } from '../monitoring';

// instrumentAxiosInstance(Axios);

export default Axios;
